import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupWifi extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "wifi",
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._probe_setup_form.init({
                wifi: data,
              });
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "wifi",
            value: data["wifi"],
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="WiFi"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
          >
            <Row>
              <Col xs={12}>
                <Row className="mb-3">
                  <Col xs={3}>
                    <ReactOFormInput
                      type="select"
                      data_key="wifi"
                      label="Enable hotspot"
                      size="md"
                      default="NoEth"
                      options={[
                        { name: "Always", value: "Always" },
                        { name: "Never", value: "Never" },
                        { name: "If no ethernet", value: "NoEth" },
                      ]}
                    />
                  </Col>
                </Row>
                <ReactOActionBar align="right" padding="0">
                  <ReactOFormInput type="submit" value="Save" color="primary" icon="save">
                    Save
                  </ReactOFormInput>
                </ReactOActionBar>
              </Col>
            </Row>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupWifi),
  //	withDefinedContext(ProbeSetupWifi, 'ProbeSetupWifi', context_exposed_methods),
  {
    define: null,
  }
);
